/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';

const ErrorMessage = ({
  text, onDismiss, color = 'danger', title = 'Error!',
}) => {
  const classStr = `alert alert-${color || 'danger'} alert-dismissible fade show mt-1`;
  return (
    <div className={classStr}>
      <strong>{title || 'Error!'}</strong>
      {' '}
      {text.charAt(0).toUpperCase() + text.slice(1)}
      {onDismiss ? <button type="button" className="btn-close" onClick={onDismiss} data-bs-dismiss="alert" /> : null}
    </div>
  );
};

export default ErrorMessage;
